import React from "react";
import { Redirect, Route } from "react-router-dom";
import authProvider from "../shared/AuthProvider";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      authProvider.isAdmin() && !authProvider.isExpire() ? (
        <Component {...props} />
      ) : (
        <Redirect to="/auth/login" />
      )
    }
  />
);

export default PrivateRoute;
